import { css } from 'styled-components';
export var FontFamily;
(function (FontFamily) {
    FontFamily["SANS"] = "'Ja', 'Helvetica', 'Arial', 'sans-serif'";
    FontFamily["BODY_SANS"] = "'Ja', 'Helvetica', 'Arial', 'sans-serif'";
})(FontFamily || (FontFamily = {}));
export var FontSize;
(function (FontSize) {
    FontSize["XXXS"] = "10px";
    FontSize["XXS"] = "12px";
    FontSize["XS"] = "14px";
    FontSize["S"] = "16px";
    FontSize["M"] = "18px";
    FontSize["L"] = "20px";
    FontSize["XL"] = "24px";
    FontSize["XXL"] = "30px";
    FontSize["XXXL"] = "40px";
    FontSize["SEMI_HUGE"] = "50px";
    FontSize["HUGE"] = "60px";
    FontSize["MASSIVE"] = "80px";
    FontSize["L2"] = "20px";
    FontSize["XL2"] = "28px";
})(FontSize || (FontSize = {}));
export var LineHeight;
(function (LineHeight) {
    LineHeight["XXXS"] = "14px";
    LineHeight["XXS"] = "18px";
    LineHeight["XS"] = "20px";
    LineHeight["S"] = "24px";
    LineHeight["M"] = "25px";
    LineHeight["L"] = "28px";
    LineHeight["XL"] = "30px";
    LineHeight["XXL"] = "34px";
    LineHeight["XXXL"] = "40px";
    LineHeight["HUGE"] = "50px";
    LineHeight["MASSIVE"] = "80px";
    LineHeight["EXTRA_MASSIVE"] = "100px";
})(LineHeight || (LineHeight = {}));
export var FontLineHeight;
(function (FontLineHeight) {
    FontLineHeight["SMALLEST"] = "11px";
    FontLineHeight["FIVE_XS"] = "12px";
    FontLineHeight["FOUR_XS"] = "15px";
    FontLineHeight["THREE_XS"] = "16px";
    FontLineHeight["XXS"] = "17px";
    FontLineHeight["XS"] = "20px";
    FontLineHeight["S"] = "21px";
    FontLineHeight["M"] = "24px";
    FontLineHeight["L"] = "26px";
    FontLineHeight["XL"] = "28px";
    FontLineHeight["XXL"] = "30px";
    FontLineHeight["THREE_XL"] = "32px";
    FontLineHeight["FOUR_XL"] = "40px";
    FontLineHeight["FIVE_XL"] = "48px";
    FontLineHeight["SIX_XL"] = "65px";
    FontLineHeight["LARGEST"] = "85px";
})(FontLineHeight || (FontLineHeight = {}));
export var FontWeight;
(function (FontWeight) {
    FontWeight["THIN"] = "100";
    FontWeight["EXTRA_LIGHT"] = "200";
    FontWeight["LIGHT"] = "300";
    FontWeight["NORMAL"] = "400";
    FontWeight["MEDIUM"] = "500";
    FontWeight["SEMI_BOLD"] = "600";
    FontWeight["BOLD"] = "700";
    FontWeight["EXTRA_BOLD"] = "800";
    FontWeight["HEAVY"] = "900";
})(FontWeight || (FontWeight = {}));
export const FontVariant = {
    BodyDesktopS: css `
    font-family: ${FontFamily.BODY_SANS};
    font-size: ${FontSize.XXS};
    line-height: ${FontLineHeight.XS};
  `,
    BodyDesktopM: css `
    font-family: ${FontFamily.BODY_SANS};
    font-size: ${FontSize.XS};
    line-height: ${FontLineHeight.M};
  `,
    BodyDesktopL: css `
    font-family: ${FontFamily.BODY_SANS};
    font-size: ${FontSize.M};
    line-height: ${FontLineHeight.XL};
  `,
    BodyMobileS: css `
    font-family: ${FontFamily.BODY_SANS};
    font-size: ${FontSize.XS};
    line-height: ${FontLineHeight.M};
  `,
    BodyMobileM: css `
    font-family: ${FontFamily.BODY_SANS};
    font-size: ${FontSize.S};
    line-height: ${FontLineHeight.L};
  `,
    HeaderS: css `
    font-family: ${FontFamily.SANS};
    font-size: ${FontSize.XXL};
    line-height: ${FontLineHeight.FOUR_XL};
  `,
    HeaderM: css `
    font-family: ${FontFamily.SANS};
    font-size: ${FontSize.XXXL};
    line-height: ${FontLineHeight.FIVE_XL};
  `,
    HeaderL: css `
    font-family: ${FontFamily.SANS};
    font-size: ${FontSize.HUGE};
    line-height: ${FontLineHeight.SIX_XL};
  `,
    HeaderXL: css `
    font-family: ${FontFamily.SANS};
    font-size: ${FontSize.MASSIVE};
    line-height: ${FontLineHeight.LARGEST};
  `,
    Label: css `
    font-family: ${FontFamily.BODY_SANS};
    font-size: ${FontSize.XXXS};
    line-height: ${FontLineHeight.SMALLEST};
    text-transform: uppercase;
  `,
    Legal: css `
    font-family: ${FontFamily.BODY_SANS};
    font-size: ${FontSize.XXXS};
    line-height: ${FontLineHeight.THREE_XS};
  `,
    SubHeaderXXS: css `
    font-family: ${FontFamily.BODY_SANS};
    font-size: ${FontSize.XXS};
    line-height: ${FontLineHeight.FIVE_XS};
    text-transform: uppercase;
  `,
    SubHeaderXS: css `
    font-family: ${FontFamily.BODY_SANS};
    font-size: ${FontSize.XS};
    line-height: ${FontLineHeight.FOUR_XS};
    text-transform: uppercase;
  `,
    SubHeaderS: css `
    font-family: ${FontFamily.BODY_SANS};
    font-size: ${FontSize.S};
    line-height: ${FontLineHeight.XXS};
    text-transform: uppercase;
  `,
    SubHeaderM: css `
    font-family: ${FontFamily.BODY_SANS};
    font-size: ${FontSize.M};
    line-height: ${FontLineHeight.S};
    text-transform: uppercase;
  `,
    SubHeaderL: css `
    font-family: ${FontFamily.SANS};
    font-size: ${FontSize.L};
    line-height: ${FontLineHeight.XXL};
  `,
    SubHeaderXL: css `
    font-family: ${FontFamily.SANS};
    font-size: ${FontSize.XL};
    line-height: ${FontLineHeight.THREE_XL};
  `,
};
export const styleBySize = (size, weight) => css `
  font-size: ${size};
  font-family: ${FontFamily.SANS};
  ${weight ? `font-weight: ${weight};` : ``}
`;
export const Font = {
    bySize: styleBySize,
    Family: FontFamily,
    LineHeight,
    Size: FontSize,
    Weight: FontWeight,
    Variant: FontVariant,
};
//# sourceMappingURL=font.js.map